<template>
  <div class="white-bg">
    <Header :tab="1" />
    <div id="banner" class="flex fww jcc aic customize-wrap" :style="`background-image: url(${customizeData.banner});`">
      <div>
        <div class="flex aic">
          <div class="banner-title">七十迈旅行</div>
          <div class="banner-subtitle">定制游</div>
        </div>
        <div class="banner-title">四步定制·省心玩</div>
        <div class="flex aic banner-steps-wrap">
          <div class="flex aic" v-for="(item, index) in customizeData.bannerSteps" :key="index">
            <img v-if="index" style="width:6px;" src="https://qishimai-1257428522.file.myqcloud.com/website/new/arrow_right.png" />
            <div class="tac banner-steps-box">
              <img class="banner-steps-img" :src="item.image">
              <div class="fs16 white-color">{{item.label}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="customize-box">
        <div class="black-color fs18 tac fw500" style="margin:10px 0 40px 0">免费定制行程</div>
        <div class="flex aic">
          <div class="fs14 fw500 black-color">目的地</div>
          <div class="customize-input-wrap">
            <input placeholder='请填写目的地' type="text" v-model="place">
          </div>
        </div>
        <div class="flex aic">
          <div class="fs14 fw500 black-color">手机号</div>
          <div class="customize-input-wrap">
            <input placeholder='请填写手机号' type="number" v-model="phoneNumber">
          </div>
        </div>
        <div class="flex aic">
          <div class="fs14 fw500 black-color">验证码</div>
          <div class="flex jcsb aic customize-input-wrap">
            <input style="width:120px" placeholder='请填写验证码' type="number" v-model="authCode">
            <div class="main-color fs12 cp" @click="sendLoginAuthCode">{{authCodeCountDown > 0 ? `${authCodeCountDown}s` : '获取验证码'}}</div>
          </div>
        </div>
        <div class="button cp" style="line-height:36px;margin:40px 0 10px 0" @click="customizeSubmit">立即定制</div>
      </div>
    </div>
    <div class="white-bg common-padding">
      <div style="width:900px;margin:auto">
        <div class="tag" style="width: 132px;">满足您要想的旅行</div>
        <div class="title">定制服务优势</div>
        <div class="describe">{{customizeData.service.text}}</div>
        <div class="flex fww jcc">
          <div class="flex aic" v-for="(item, index) in customizeData.service.steps" :key="index">
            <img v-if="index" style="width:14px;" src="https://qishimai-1257428522.file.myqcloud.com/website/new/step_icon.png" />
            <div class="tac service-box">
              <img class="service-box-img" :src="item.image">
              <div class="fs16 fw500 black-color">{{item.name}}</div>
              <div class="fs12 gray-color" style="padding:4px 12px;">{{item.content}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="warp-bg common-padding">
      <div class="flex fxdc aic" style="width:900px;margin:auto">
        <div class="tag" style="width: 150px;">定制我们是最专业的</div>
        <div class="title">专业定制师</div>
        <div class="describe">{{customizeData.customizer.text}}</div>
        <div class="flex fww jcc">
          <div class="customizer-box" v-for="(item, index) in customizeData.customizer.memberlist" :key="index" @mouseover="() => customizerContentOnShow = index" @mouseleave="() => customizerContentOnShow = undefined">
            <img class="customizer-box-img" :src="item.image">
            <div style="height:94px;margin:2px 10px;">
              <div class="flex jcsb aic" style="margin-bottom:10px">
                <div class="fs13 fw500 black-color">{{item.name}}</div>
                <div class="flex aic customizer-experience">{{item.experience}}</div>
              </div>
              <div class="fs12 gray-color">{{item.intro}}</div>
            </div>
            <div class="customizer-mask" v-if="index === customizerContentOnShow">
              <div class="customizer-content fs12 lh2">
                <div class="tac black-color">定制师简介</div>
                <div class="gray-color">{{item.content}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showSuccessModal" class='modal-mask'>
      <div class='modal-box'>
        <img src="https://qishimai-1257428522.file.myqcloud.com/website/new/customerservice_avatar.png" class="modal-avatar" />
        <div class='modal-title' style='margin-top:50px;'>提交成功</div>
        <div class='modal-content' style='margin-top:6px;'>我们已收到您的需求</div>
        <div class='modal-content'>旅行顾问将在<span style="color: #0BA09A;">24小时之内联系您</span></div>
        <div class='modal-content' style='margin-bottom:16px;'>请保持电话畅通</div>
        <div class='modal-btn' @click="showSuccessModal = false">好的</div>
      </div>
    </div>
    <div v-if="showToast" class="toast">
      <div>{{toastContent}}</div>
    </div>
    <Footer />
    <FloatingWindow />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import FloatingWindow from '@/components/FloatingWindow.vue';
import { get, post } from '@/utils/config.http';
import { api } from '@/utils/constVar';
import customizeData from '@/utils/staticData/customizeData';

export default {
  name: 'Customize',
  components: { Header, Footer, FloatingWindow },
  data () {
    return {
      customizeData,
      groupCityIndex: 0,
      phoneNumber: '',
      authCode: '',
      place: '',
      authCodeCountDown: 0,
      showSuccessModal: false,
      showToast: false,
      toastContent: '',
      customizerContentOnShow: undefined,
    }
  },
  methods: {
    sendLoginAuthCode() {
      if (this.authCodeCountDown > 0) {
        return;
      }
      if (this.phoneNumber) {
        const res = /^1\d{10}$/.test(this.phoneNumber);
        if (!res) {
          this.toast('请正确输入手机号！');
          return;
        }
        return get(api.getAuthCode, { phoneNumber: this.phoneNumber }).then((res) => {
          this.toast('发送成功！');
          this.authCodeCountDown = 60;
          this.authCodeCountDownHandle();
        }).catch((err) => {
          this.toast('发送验证码失败，请稍后重试');
        })
      } else {
        this.toast('请填写手机号！');
      }
    },
    authCodeCountDownHandle() {
      setTimeout(() => {
        this.authCodeCountDown = this.authCodeCountDown - 1;
        this.authCodeCountDownHandle()
      }, 1000)
    },
    customizeSubmit() {
      if ( this.phoneNumber === '' || this.place === '' || this.authCode === '' ) {
        this.toast('请完整填写信息！');
        return;
      }
      return post(api.insertClue, {
        phoneNumber: this.phoneNumber,
        authCode: this.authCode,
        place: this.place,
        source: '官网',
      }).then((res) => {
        this.phoneNumber = '',
        this.authCode = '',
        this.place = '',
        this.authCodeCountDown = 0,
        // this.toast('提交失败！');
        this.showSuccessModal = true;
      }).catch((err) => {
        this.toast('提交失败！');
      })
    },
    copyToClipboard(s) {
      if (window.clipboardData) {
          window.clipboardData.setData('text', s);
          this.toast('复制成功！');
      } else {
        (function(s) {
          document.oncopy = function(e) {
            e.clipboardData.setData('text', s);
            e.preventDefault();
            document.oncopy = null;
          }
        })(s);
        document.execCommand('Copy');
        this.toast('复制成功！');
      }
    },
    toast(content) {
      this.toastContent = content;
      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
      }, 2000)
    }
  },
}
</script>

<style scoped>
.banner-title {
  font-size: 50px;
  font-weight: 600;
  line-height: 74px;
  color: #FFFFFF;
}
.banner-subtitle {
  margin-left: 14px;
  padding: 0 18px;
  background: #FFF500;
  border-radius: 7px;
  font-size: 30px;
  font-weight: 600;
  line-height: 44px;
  color: #000000;
}
.banner-steps-wrap {
  margin-top: 20px;
  background: rgba(255, 255, 255, 0.13);
  border-radius: 14px;
}
.banner-steps-box {
  margin: 16px 20px;
}
.banner-steps-img {
  width: 24px;
  margin-bottom: 6px;
}
.customize-wrap {
  height: 34.6vw;
  max-height: 664px;
  min-height: 415px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.customize-box {
  width: 270px;
  margin: 100px 0 0 100px;
  padding: 28px;
  box-shadow: 0px 3px 14px rgba(165, 165, 165, 0.24);
  border-radius: 11px;
  background-color: #fff;
}
.customize-input-wrap {
  height: 36px;
  width: 190px;
  margin: 6px 0 10px 12px;
  padding: 0 10px;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
}
input {
  height: 36px;
  width: 190px;
}
.service-box {
  width: 148px;
  margin: 20px 10px 0 10px;
}
.service-box-img {
  width: 100%;
}
.customizer-box {
  position: relative;
  width: 205px;
  margin: 40px 20px 0 0;
  background: #FFFFFF;
  box-shadow: 0px 3px 16px rgba(128, 128, 128, 0.16);
  border-radius: 8px;
  overflow: hidden;
}
.customizer-box-img {
  width: 100%;
}
.customizer-experience {
  padding: 2px 6px;
  border: 1px solid #17A09A;
  border-radius: 15px;
  font-size: 12px;
  line-height: 14px;
  color: #17A09A;
}
.customizer-mask {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.36);
}
.customizer-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/Customize.vue